module.exports = __webpack_public_path__ + "static/media/madame-figaro.5bd38876.png";